import { graphClient } from '../../graph-client'
import {
  CREATE_LIVE_DETAIL_PEOPLE,
  DELETE_LIVE_DETAIL_PEOPLE_POINTS,
  GET_LIVE_DETAILS_PEOPLE,
  GET_LIVE_DETAIL_PEOPLE,
  GET_LIVE_DETAIL_PEOPLE_BY_USER_ID,
  UPDATE_LIVE_DETAIL_PEOPLE,
} from './gql'
import type {
  Create,
  DeletePoints,
  Get,
  GetByUserId,
  GetList,
  Update,
} from './types'

class LiveDetailPeopleService {
  async getList({ liveId }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_LIVE_DETAILS_PEOPLE,
      {
        liveId: Number(liveId),
      },
    )

    return request?.getLivesDetailsPeoplesByLiveId
  }

  async get({ liveDetailPeopleId }: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_LIVE_DETAIL_PEOPLE,
      {
        liveDetailPeopleId: Number(liveDetailPeopleId),
      },
    )

    return request?.getLiveDetailPeople
  }

  async getByUserId(params: GetByUserId.Input) {
    const request = await graphClient.request<GetByUserId.Output>(
      GET_LIVE_DETAIL_PEOPLE_BY_USER_ID,
      params,
    )

    return request?.getLiveDetailPeopleFirst
  }

  async update({ liveId, liveDetailPeopleId, ...rest }: Update.Input) {
    const request = await graphClient.request<Update.Output>(
      UPDATE_LIVE_DETAIL_PEOPLE,
      {
        liveId: Number(liveId),
        liveDetailPeopleId: Number(liveDetailPeopleId),
        ...rest,
      },
    )

    return request?.updateLiveDetailPeople
  }

  async create({ liveId }: Create.Input) {
    const request = await graphClient.request<Create.Output>(
      CREATE_LIVE_DETAIL_PEOPLE,
      {
        liveId: Number(liveId),
      },
    )

    return request?.createLiveDetailPeople
  }

  async deletePoints({ liveDetailPeopleId, liveId }: DeletePoints.Input) {
    const request = await graphClient.request<DeletePoints.Output>(
      DELETE_LIVE_DETAIL_PEOPLE_POINTS,
      {
        liveDetailPeopleId: Number(liveDetailPeopleId),
        liveId: Number(liveId),
      },
    )

    return request?.deleteLiveDetailPeoplePoints
  }
}

export const liveDetailPeopleService = new LiveDetailPeopleService()
